// extracted by mini-css-extract-plugin
export default {"footer":"SharedContentFooter_footer__RWY71","iconWrapper":"SharedContentFooter_iconWrapper__mUT7n","img":"SharedContentFooter_img__oeCeq"};